"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinterestScript = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const PINScript = `
!function(e){if(!window.pintrk){window.pintrk = function () {
window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
  n=window.pintrk;n.queue=[],n.version="3.0";var
  t=document.createElement("script");t.async=!0,t.src=e;var
  r=document.getElementsByTagName("script")[0];
r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
pintrk('load', '2613487462818');
pintrk('page');
`.trim();
const PinterestScript = () => {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("script", { id: "pinterest-script", dangerouslySetInnerHTML: { __html: PINScript } }) }));
};
exports.PinterestScript = PinterestScript;
